// The CS:S sound files used for weapons and impacts (read from the player's game, never shipped).
// Kept free of other imports so the model worker can use it.

export type SampleId =
  | 'knifeDeploy'
  | 'knifeSlash'
  | 'knifeHitWall'
  | 'knifeHitMetal'
  | 'glassBreak'
  | 'uspShot'
  | 'uspSilenced'
  | 'uspClipOut'
  | 'uspClipIn'
  | 'uspSlideBack'
  | 'uspSlideRelease'
  | 'uspSilencerOn'
  | 'uspSilencerOff'
  | 'impactConcrete'
  | 'impactMetal'
  | 'impactWood'
  | 'impactGlass'
  | 'ricochet';

const range = (base: string, n: number) => Array.from({ length: n }, (_, i) => `${base}${i + 1}`);

/** CS:S sound files, as paths under sound/ without ".wav" (missing variants are skipped). */
export const CSS: Record<SampleId, string[]> = {
  knifeDeploy: ['weapons/knife/knife_deploy1'],
  knifeSlash: range('weapons/knife/knife_slash', 2),
  knifeHitWall: ['weapons/knife/knife_hitwall1'],
  knifeHitMetal: ['weapons/knife/knife_hitwall1'],
  glassBreak: range('physics/glass/glass_sheet_break', 3),
  uspShot: ['weapons/usp/usp_unsil-1'],
  uspSilenced: ['weapons/usp/usp1', 'weapons/usp/usp2'],
  uspClipOut: ['weapons/usp/usp_clipout'],
  uspClipIn: ['weapons/usp/usp_clipin'],
  uspSlideBack: ['weapons/usp/usp_slideback', 'weapons/usp/usp_slideback2'],
  uspSlideRelease: ['weapons/usp/usp_sliderelease'],
  uspSilencerOn: ['weapons/usp/usp_silencer_on'],
  uspSilencerOff: ['weapons/usp/usp_silencer_off'],
  impactConcrete: range('physics/concrete/concrete_impact_bullet', 4),
  impactMetal: range('physics/metal/metal_solid_impact_bullet', 4),
  impactWood: range('physics/wood/wood_solid_impact_bullet', 5),
  impactGlass: range('physics/glass/glass_impact_bullet', 4),
  ricochet: range('weapons/fx/rics/ric', 5),
};

/** Every CS:S sound file we use, as game paths ("sound/weapons/knife/knife_deploy1.wav"). */
export const CSS_SOUND_FILES: string[] = [...new Set(Object.values(CSS).flat())].map((p) => `sound/${p}.wav`);
